export default "__VITE_ASSET__CDC0WEkj__"